import React, { useRef } from "react";

import Stack from "@busbud/design-system-components/dist/Stack";
import type { Choices } from "@busbud/int-schemas/lib";
import type * as UDM from "@busbud/int-schemas/udm";

import { BusRows } from "./bus-horizontal-rows";

type Props = {
  active_floor: number;
  active_seat: UDM.SeatCell | undefined;
  vehicle_layout: UDM.Bus["layout"];
  vehicle_driver: UDM.Bus["driver"];
  already_assigned_seat_ids: (string | null)[];
  active_seat_id: string | null;
  onSeatChange: (seat: UDM.SeatCell) => void;
  onGenderChange?: (gender: Choices.Gender) => void;
  is_checkout?: boolean;
  seatClassResolver?: (seat_id: string) => string | null;
};

export const BusHorizontal: React.FC<Props> = props => {
  const {
    active_floor,
    active_seat,
    vehicle_layout,
    active_seat_id,
    already_assigned_seat_ids,
    onSeatChange,
    onGenderChange,
    seatClassResolver
  } = props;
  const floor = vehicle_layout![active_floor];

  const rows_count = useRef(
    vehicle_layout!.reduce((current, floor) => {
      const nb_rows = floor?.cells?.length || 0;

      return Math.max(nb_rows, current);
    }, 0)
  );

  return (
    <Stack direction="row" spacing={2.5}>
      <></>
      <BusRows
        active_seat={active_seat}
        floor={floor}
        rows_count={rows_count.current}
        active_seat_id={active_seat_id}
        already_assigned_seat_ids={already_assigned_seat_ids}
        onSeatChange={onSeatChange}
        onGenderChange={onGenderChange}
        seatClassResolver={seatClassResolver}
      />
    </Stack>
  );
};
